import SiteThumbnail from './SiteThumbnail';
import './SiteThumbnail.scss';

export default SiteThumbnail;
